import { useState, useCallback } from 'react';

type FilterState<T> = {
  [K in keyof T]: T[K];
};

type SetFilter<T> = <K extends keyof T>(key: K, value: T[K]) => void;

export const useFilters = <T extends Record<string, any>>(
  initialFilters: T
) => {
  const [filters, setFilters] = useState<FilterState<T>>(initialFilters);

  const setFilter: SetFilter<T> = useCallback((key: keyof T, value) => {
    setFilters(prevFilters => ({
      ...prevFilters,
      [key]: value
    }));
  }, []);

  return { filters, setFilter };
};
